import {Action} from 'redux';

export enum TUserParams {
  SET_USER_PARAMS = 'SET_USER_PARAMS',
}

export interface ISetUserParams extends Action {
  type: TUserParams.SET_USER_PARAMS;
  payload: any;
}

export const ASetUserParams = (payload: any): ISetUserParams => ({type: TUserParams.SET_USER_PARAMS, payload});

